var $=jQuery;
$(function(){
    $('.collection_faq_list li').each(function(){
        $(this).find('.iconfont').click(function(){
            console.log('获取的内容',$(this));
            if($(this).hasClass('icon-down')) {
                console.log('点击展开');
                $(this).parent().siblings('p').removeClass('none');
                $(this).addClass('icon-up').removeClass('icon-down');
            }else{
                console.log('点击折叠');
                $(this).parent().siblings('p').addClass('none');
                $(this).addClass('icon-down').removeClass('icon-up');
            }
        })
    })
    if(jQuery(window).width()>769){
      $('.collection_foot_description_con ul li').each(function(){
        var list_img_height=$(this).find('.collection_foot_description_con_right img').height();
        var context_height=$(this).find('.collection_foot_description_con_left_con').height();
        console.log('图片高度',list_img_height,'---','文案高度',context_height);
        if(list_img_height>context_height){
          console.log('图片的高度高');
          $(this).find('.collection_foot_description_con_left .toggle-btn').remove();
        }else{
          console.log('文案的高度高');
          const image =  $(this).find('.collection_foot_description_con_right img');
          const text =  $(this).find('.collection_foot_description_con_left');
          const content =  $(this).find('.collection_foot_description_con_left_con');
          function adjustTextHeight() {
            const imageHeight = image.height(); // 获取图片实际高度
            text.css('height',imageHeight);
            content.css('height',imageHeight - 25);
            $(this).find('.collection_foot_description_con_left .toggle-btn').remove();
          }
          adjustTextHeight();
        }
      })
    }
})
document.addEventListener('DOMContentLoaded', function () {
  $('.collection_foot_description_con li').each(function(){
    const image =  $(this).find('.collection_foot_description_con_right img');
    const text =  $(this).find('.collection_foot_description_con_left');
    const content =  $(this).find('.collection_foot_description_con_left_con');
    const button = $(this).find('.toggle-btn');
    function adjustTextHeight() {
      const imageHeight = image.height(); // 获取图片实际高度
      text.css('height',imageHeight);
      content.css('height',imageHeight - 31);
    }
    // adjustTextHeight();
      if(jQuery(window).width()>769){
        // 确保图片加载后调整高度
        if (image[0].complete) {
          adjustTextHeight(); // 图片已加载时立即调整高度
        } else {
          image.on('load', adjustTextHeight); // 使用 jQuery 的 `on` 方法监听加载事件
        }

        // 窗口大小变化时重新调整
        $(window).on('resize', adjustTextHeight);
      }
      // 展开/折叠按钮点击事件
      button.on('click', function() {
        if (text.hasClass('expanded')) {
          text.removeClass('expanded');
          content.css({
            overflow: 'hidden',
            height: $(this).closest('li').find('.collection_foot_description_con_right img').height() - 25,
          });
          text.css('height', $(this).closest('li').find('.collection_foot_description_con_right img').height());
          button.text('view more');
        } else {
          text.addClass('expanded');
          content.css({
            overflow: 'visible',
            height: 'auto',
          });
          text.css('height', 'auto');
          button.text('pack up');
        }
      });
    })
  });
  